<template>
  <el-dropdown
    trigger="click"
    @command="handleCommand"
  >
    <el-avatar :size="24">{{ letter }}</el-avatar>
    <el-dropdown-menu
      slot="dropdown"
      placement="top"
    >

      <el-dropdown-item
        command="token"
        icon="el-icon-coin"
      >增加额度</el-dropdown-item>
      <el-dropdown-item
        command="password"
        icon="el-icon-lock"
      >修改密码</el-dropdown-item>
      <el-dropdown-item
        v-if="!isSaas"
        command="network"
        icon="el-icon-setting"
      >配置网络</el-dropdown-item>
      <el-dropdown-item
        command="logout"
        icon="el-icon-switch-button"
      >退出登录</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { logout } from '@/api/base';
import EventBus from '@/lib/events';
import router from '@/router';

export default {
  name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    isSaas: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    letter() {
      return this.user.fullName.slice(0, 1).toUpperCase();
    },
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      }
      if (command === 'token') {
        this.addToken();
      }
      if (command === 'password') {
        this.changePassword();
      }
      if (command === 'network') {
        this.configureNetwork();
      }
    },
    logout() {
      logout().then(() => {
        EventBus.$emit('logout');
      });
    },
    addToken() {
      router.push({ name: 'TokenManage' });
    },
    changePassword() {
      router.push({ name: 'ResetPassword' });
    },
    configureNetwork() {
      router.push({ name: 'Network' });
    },
  },
};
</script>

<style scoped>
/* Add any specific styles for the avatar or dropdown here */
.el-dropdown {
  cursor: pointer;
  font-size: 0;
}
</style>
